<template>
  <div class="margin-top-half">
    <div
      class="content-devx"
    >
      <DxDataGrid
        id="TasksDatabase-datagrid"
        :data-source="taskDefinitions"
        :column-min-width="70"
        :column-auto-width="true"
        :allow-column-resizing="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        @exporting="onExporting"
        @RowRemoved="callToDeleteTask"
        @toolbar-preparing="onToolbarPreparing($event)"
      >
        <DxSelection
          mode="single"
        />
        <DxStateStoring
          :enabled="true"
          type="localStorage"
          storage-key="TasksDatabase"
        />
        <DxHeaderFilter :visible="true" />
        <DxExport
          :enabled="false"
        />
        <DxPaging :page-size="gridSettings.pageSize" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="pageSizes"
          :show-info="true"
          info-text="{2} items"
        />
        <DxSearchPanel
          :visible="true"
          :width="200"
          :placeholder="$t('Search_placeholder')"
        />
        <DxEditing
          :allow-updating="true"
          :allow-deleting="true"
          :confirm-delete="true"
        >
          <DxTexts
            :confirm-delete-message="$t('Confirm_Delete_Text')"
            :confirm-delete-title="$t('Confirm_Delete_Title')"
          />
        </DxEditing>
        <DxColumn
          data-field="activity"
          :width="350"
          :caption="$t('Configuration.Activity')"
          :allow-header-filtering="true"
          alignment="left"
        />
        <DxColumn
          data-field="name"
          :caption="$t('Configuration.Name')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          type="buttons"
          :fixed="gridSettings.fixed"
          :fixed-position="gridSettings.fixedPosition"
        >
          <DxButton
            name="find"
            icon="find"
            :on-click="showDetail"
          />
          <DxButton
            name="edit"
            icon="edit"
            :on-click="editTask"
          />
          <DxButton
            name="delete"
            icon="trash"
          />
        </DxColumn>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxHeaderFilter,
  DxStateStoring,
  DxPager,
  DxSelection,
  DxButton,
  DxEditing,
  DxTexts,
} from 'devextreme-vue/data-grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import settings from '../../../../js/commonSettings';

export default {
  name: 'TasksDatabase',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxHeaderFilter,
    DxStateStoring,
    DxPager,
    DxSelection,
    DxButton,
    DxEditing,
    DxTexts,
  },
  props: {
    taskDefinitions: { type: Array, default: () => [] },
  },
  data() {
    return {
      pageSizes: [5, 10, 20],
    };
  },
  computed: {
    gridSettings() {
      return settings.datagrid;
    },
  },
  methods: {
    showDetail(rowSelected) {
      this.setTaskDefinitionId(rowSelected.row.data.id);
      this.$f7.views.main.router.navigate('/viewTaskDetail/', { reloadCurrent: true });
    },
    editTask(rowSelected) {
      this.setTaskDefinitionId(rowSelected.row.data.id);
      this.$f7.views.main.router.navigate('/editTaskDefinition/', { reloadCurrent: true });
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          elementAttr: {
            class: 'add-task',
          },
          onClick: () => {
            this.initStore();
            this.$f7.views.main.router.navigate('/createTaskDefinition/', { reloadCurrent: true });
          },
        },
      });
    },
    async callToDeleteTask(rowSelected) {
      this.$f7.preloader.show();
      try {
        await this.deleteTaskDefinition(rowSelected.data.id);
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onExporting(e) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('TasksDatabase');
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer()
          .then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'TasksDatabase.xlsx');
          });
      });
      e.cancel = true;
    },
    ...mapActions('TaskDefinition', ['setTaskDefinitionId', 'initStore', 'deleteTaskDefinition']),

  },
};
</script>
<style lang="scss" scoped>
@import './TasksDatabase.styles.scss';
</style>
